export default "__VITE_ASSET__e650fae6__"